/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Air_Handler_Unit_Actuator_Dialog_SubtitleInputs */



/**
* | output |
* | --- |
* | "Automatic or forcing control" |
*
* @param {Air_Handler_Unit_Actuator_Dialog_SubtitleInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const air_handler_unit_actuator_dialog_subtitle = /** @type {((inputs?: Air_Handler_Unit_Actuator_Dialog_SubtitleInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Air_Handler_Unit_Actuator_Dialog_SubtitleInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Automatic or forcing control")
	return /** @type {LocalizedString} */ ("Contrôle automatique ou forçage")
});